module.exports = __webpack_public_path__ + "img/logo_other.a34c663f.png";